const AddCurrencyButtom = ({ addCurrency }) => {
  return (
    <div className="AddCurrencyBottom" onClick={addCurrency}>
      + Add Currency
    </div>
  );
};

export default AddCurrencyButtom;
